import { render, staticRenderFns } from "./GeselecteerdeBewijzen.vue?vue&type=template&id=c2678d30&scoped=true"
import script from "./GeselecteerdeBewijzen.vue?vue&type=script&lang=js"
export * from "./GeselecteerdeBewijzen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2678d30",
  null
  
)

export default component.exports